webpackJsonp([18027074326707],{

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/final.210e021e.png";

/***/ }),

/***/ 760:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _final = __webpack_require__(97);
	
	var _final2 = _interopRequireDefault(_final);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 1: Convert Header Title to Link'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'ll use ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'react-router'
	      ),
	      ' to convert the title in the header to a clickable link that will always take the user back to the homepage. We won\'t make use of the functionality in this Quickstart, but it\'s a good practice to follow.'
	    ),
	    _react2.default.createElement(_QuickstartBranch2.default, { branch: 'routing.1' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Update the Header'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Open the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Header'
	      ),
	      ' component and find this line:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // src/components/Header.js\n      <div className="navbar-brand">\n        Lore Quickstart\n      </div>\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next, import the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Link'
	      ),
	      ' tag from ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'react-router'
	      ),
	      ' and update the code to look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // src/components/Header.js\n      import { Link } from \'react-router\';\n      ...\n      <Link className="navbar-brand" to="/">\n        Lore Quickstart\n      </Link>\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the code above, we\'ve converted the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'div'
	      ),
	      ' tag into a clickable link, and set the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'to'
	      ),
	      ' property to the root URL (',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/'
	      ),
	      '). Now whenever you click the link, you\'ll be taken back to the homepage.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, your application will look the same visually, but now the title in the header will be a clickable link that takes you back to the homepage.'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _final2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/Header.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import { Link } from \'react-router\';\n\n        export default createReactClass({\n          displayName: \'Header\',\n\n          render() {\n            return (\n              <nav className="navbar navbar-default navbar-static-top header">\n                <div className="container">\n                  <div className="navbar-header">\n                    <Link className="navbar-brand" to="/">\n                      Lore Quickstart\n                    </Link>\n                  </div>\n                </div>\n              </nav>\n            );\n          }\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { Link } from \'react-router\';\n\n        class Header extends React.Component {\n\n          render() {\n            return (\n              <nav className="navbar navbar-default navbar-static-top header">\n                <div className="container">\n                  <div className="navbar-header">\n                    <Link className="navbar-brand" to="/">\n                      Lore Quickstart\n                    </Link>\n                  </div>\n                </div>\n              </nav>\n            );\n          }\n\n        }\n\n        export default Header;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { Link } from \'react-router\';\n\n        class Header extends React.Component {\n\n          render() {\n            return (\n              <nav className="navbar navbar-default navbar-static-top header">\n                <div className="container">\n                  <div className="navbar-header">\n                    <Link className="navbar-brand" to="/">\n                      Lore Quickstart\n                    </Link>\n                  </div>\n                </div>\n              </nav>\n            );\n          }\n\n        }\n\n        export default Header;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to create a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Feed'
	      ),
	      ' component for displaying tweets and ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-2/' },
	        'add it to the routes'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-routing-step-1-js-3dfe69f753227e34ff8a.js